import { AccordionEmployee } from '../../Components/EmployeeEvaluation/accordionEmployee'
import { DropBox } from '../../Components/EmployeeEvaluation/drobBox'
import { useCallback, useEffect, useState } from 'react'
import { getEmployeesURL, getEvaluationList, getSalaryBand } from '../../API/Employee/Employee'
import { salaryEvaluationGraphTranslate } from '../../i18n/translatedMessages'
import { Select } from '../../Components/Employee/Select/Select'
import Loading from '../../Components/Loading/Loading'
import List from '../../API/Lists/Lists.js'
import countryMapper from '../../Utils/CountriesMapper.js'
import areasMapper from '../../Utils/AreasMapper.js'
import levelsMapper from '../../Utils/LevelsMapper.js'

import { translate as translateAreas } from '../../i18n/Library/areasCorrelation.js'
import { translate as translatePosition } from '../../i18n/Library/hierarchicalLevel'
import { useIntl } from 'react-intl'
import { HiMagnifyingGlass } from 'react-icons/hi2'
import { PerformanceSalaryGraph } from '../../../src/Components/EmployeeEvaluation/PerformanceSalaryGraph'
import { PotentialSalaryGraph } from '../../../src/Components/EmployeeEvaluation/PotentialSalaryGraph'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { SalaryBand } from '../../../src/Components/EmployeeEvaluation/salaryBand'
import { FaArrowLeft, FaArrowRight, FaRegTrashAlt, FaSearch } from 'react-icons/fa'
import CarouselAvaliation from '../../Components/EmployeeEvaluation/carouselAvaliation'

export function EmployeeEvaluationSalary() {
	const token = localStorage.getItem('token')
	const getLanguage = useIntl()
	const language = getLanguage.locale === 'PT-BR' ? 'pt' : 'es'
	const location = useLocation()
	const currentPath = location.pathname

	const [loading, setLoading] = useState(false)
	const [countries, setCountries] = useState([])
	const [areas, setAreas] = useState([])
	const [levels, setLevels] = useState([])

	const [page, setPage] = useState(1)
	const [totalPages, setTotalPages] = useState(0)

	const [filteredEvaluations, setFilteredEvaluations] = useState([])

	const [filters, setFilters] = useState({
		country: '',
		area: '',
		level: '',
		text: '',
	})

	const [textFilter, setTextFilter] = useState('')

	const [selectedEvaluation, setSelectedEvaluation] = useState(null)
	const [evaluations, setEvaluations] = useState([])

	const fetchData = useCallback(async () => {
		try {
			setLoading(true)
			const company = JSON.parse(localStorage.getItem('user')).id

			const { area, level, country, text } = filters

			const resEvaluationList = await getEvaluationList(company)
			const evaluationRows = resEvaluationList.rows
			setEvaluations(evaluationRows)

			const evaluationId = evaluationRows[selectedEvaluation ?? evaluationRows.length - 1]?.id

			if (evaluationRows.length > 0 && selectedEvaluation === null) {
				setSelectedEvaluation(evaluationRows.length - 1)
			}

			const [resArea, resCountry, resLevel] = await Promise.all([List.areas(), List.countries(), List.levels()])

			setCountries(resCountry.map(countryMapper.toDomain))
			setAreas(resArea.map(areasMapper.toDomain))
			setLevels(resLevel.map(levelsMapper.toDomain))

			const [resSalaryBand] = await Promise.all([getSalaryBand(company, page, area, level, country, text, evaluationId)])

			const employeeImgs = await getEmployeesURL(company, token)

			const updatedEvaluations = resSalaryBand.body.map(item => ({
				...item,
				profileImg: employeeImgs.find(img => img.mydnaUserEmail === item.email)?.url || null,
			}))

			// setEvaluations(resSalaryBand.body)
			setFilteredEvaluations(updatedEvaluations)
			setTotalPages(Math.ceil(resSalaryBand.count / 50))
		} catch (error) {
			console.error('Error:', error)
		} finally {
			setLoading(false)
		}
	}, [page, filters, selectedEvaluation])

	useEffect(() => {
		fetchData()
	}, [fetchData])

	const handleFilterText = e => {
		const text = e.target.value

		setTextFilter(text)
	}

	const handleKeyDown = e => {
		if (e.key === 'Enter' && textFilter.length > 0) {
			setFilters(prevFilters => ({
				...prevFilters,
				text: textFilter,
			}))
			setPage(1)
		}
	}

	const handleSearchText = () => {
		setFilters(prevFilters => ({
			...prevFilters,
			text: textFilter,
		}))
		setPage(1)
	}

	const handleFilter = e => {
		const selectedOption = e.target.value

		setFilters(prev => ({
			...prev,
			[e.target.name]: selectedOption || null,
		}))
		setPage(1)
	}

	const cleanFilters = () => {
		setFilters({
			area: '',
			level: '',
			country: '',
			text: '',
		})
		setTextFilter('')
		setPage(1)
	}

	const translatedAreas = [...areas]
		.sort((a, b) => a.value.localeCompare(b.value))
		.map(item => ({
			...item,
			value: translateAreas[language][item?.value],
		}))

	const translatedLevels = [...levels]
		.sort((a, b) => a.value.localeCompare(b.value))
		.map(item => ({
			...item,
			value: translatePosition[language][item?.value],
		}))

	return (
		<>
			{loading ? (
				<Loading />
			) : (
				<>
					<h3 className='tw-mb-4 tw-font-bold'>{salaryEvaluationGraphTranslate.salaryGraphTitle}</h3>
					<div className='tw-text-lg tw-mb-4 tw-pr-20'>{salaryEvaluationGraphTranslate.salaryGraphText}</div>
					<div className='tw-rounded-xl tw-shadow-md tw-p-6 border tw-mr-20'>
						<div className='tw-mb-5'>
							<CarouselAvaliation evaluations={evaluations} setSelectedEvaluation={setSelectedEvaluation} selectedEvaluation={selectedEvaluation} />
						</div>
						<div className='tw-w-full tw-flex tw-space-x-3 tw-items-center'>
							<div className='tw-w-7/12 border border-grey tw-rounded-lg py-1 px-3 tw-flex tw-items-center tw-justify-center tw-mt-1'>
								<HiMagnifyingGlass size={22} className='text-dark-grey' />
								<input
									type='text'
									className='border border-0 p-0 m-0 ms-4 tw-w-full'
									placeholder='Buscar Colaborador'
									onKeyDown={handleKeyDown}
									onChange={handleFilterText}
									value={textFilter}
								/>
							</div>

							<div className='tw-w-1/5'>
								<Select placeholder='País' list={countries} onChange={handleFilter} name='country' value={filters.country} />
							</div>
							<div className='tw-w-1/5'>
								<Select placeholder='Área' list={translatedAreas} onChange={handleFilter} name='area' value={filters.area} />
							</div>

							<div className='tw-w-1/5'>
								<Select placeholder={'Nivel Hierárquico'} list={translatedLevels} onChange={handleFilter} name='level' value={filters.level} />
							</div>
							<button
								className={`tw-w-[9%] tw-text-sm tw-flex tw-px-1 tw-items-center tw-justify-center tw-mt-1 ${
									Object.values(filters).some(filter => filter) ? 'tw-bg-purple-500 tw-text-white' : 'tw-text-gray-400'
								}`}
								style={{ height: 45, border: '1px solid #CBD5E1', borderRadius: 8 }}
								onClick={cleanFilters}
								disabled={Object.values(filters).every(filter => filter === '')}
							>
								<FaRegTrashAlt className='me-1' size={12} />
								Limpar
							</button>
							<button
								className={`tw-w-[9%] tw-text-sm tw-flex tw-px-2 tw-items-center tw-justify-center tw-mt-1 ${
									textFilter !== '' ? 'tw-bg-purple-500 tw-text-white' : 'tw-text-gray-400'
								}`}
								style={{ height: 45, border: '1px solid #CBD5E1', borderRadius: 8 }}
								onClick={handleSearchText}
								disabled={!textFilter}
							>
								<FaSearch className='me-1' size={12} />
								Pesquisar
							</button>
						</div>
						<div className='tw-text-purple-600'>
							<AccordionEmployee evaluations={filteredEvaluations}>
								<DropBox path={currentPath}>
									<SalaryBand title={language === 'es' ? 'Informar Banda Salarial del Colaborador' : 'Informar Banda Salarial do Colaborador'} />
									<PerformanceSalaryGraph title={salaryEvaluationGraphTranslate.salaryBandPerformance} chart={true} />
									<PotentialSalaryGraph title={salaryEvaluationGraphTranslate.salaryBandPortential} chart={true} />
								</DropBox>
							</AccordionEmployee>
						</div>
					</div>
				</>
			)}
		</>
	)
}
